var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDailyActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFB60C",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7914 3L14.7981 4.11298L17 2.50202V1H15V3H9.00001V1H7.00001V3H3.00001C2.73479 3 2.48044 3.10536 2.2929 3.29289C2.10536 3.48043 2.00001 3.73478 2.00001 4V20C2.00001 20.2652 2.10536 20.5196 2.2929 20.7071C2.48044 20.8946 2.73479 21 3.00001 21H21C21.2652 21 21.5196 20.8946 21.7071 20.7071C21.8947 20.5196 22 20.2652 22 20V11.7293L20 12.7048V19H4.00001V9H20V11.7733C20.0612 11.7142 20.1231 11.6545 20.1854 11.5944L20.1854 11.5944C20.8124 10.9895 21.4842 10.3414 22 9.78692V4C22 3.73478 21.8947 3.48043 21.7071 3.29289C21.5196 3.10536 21.2652 3 21 3H18.7914ZM11 13H6.00001V17H11V13ZM5.86951 5.41943L5.42308 4.11298L7.65522 3.24201L5.86951 5.41943Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyActive);
export default __webpack_public_path__ + "static/media/dailyActive.36b406ac88272172c871f84004aef32d.svg";
export { ForwardRef as ReactComponent };